import { render } from "./CustomCursor.vue?vue&type=template&id=c4ef4b62&scoped=true"
import script from "./CustomCursor.vue?vue&type=script&lang=js"
export * from "./CustomCursor.vue?vue&type=script&lang=js"

import "./CustomCursor.vue?vue&type=style&index=0&id=c4ef4b62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4ef4b62"]])

export default __exports__